import { Link } from 'react-router-dom';

const AudienceSegment = () => {
  return (
    <section style={{ background: '#080808' }}>
      {/* Top label */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-20 pb-10 text-center">
        <div className="inline-flex items-center gap-3 mb-5">
          <div className="h-px w-8 bg-artden-coral" />
          <span className="section-label">Ages & Experiences</span>
          <div className="h-px w-8 bg-artden-coral" />
        </div>
        <h2 className="font-cormorant font-medium text-white leading-[1.0] tracking-tight" style={{ fontSize: 'clamp(2.5rem, 5vw, 4.5rem)' }}>
          Something for Every<br />
          <em className="font-light italic" style={{ color: '#ffb300' }}>Creative Soul</em>
        </h2>
      </div>

      {/* Split layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2">

        {/* Kids side */}
        <div className="relative min-h-[520px] group overflow-hidden cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/336baa08cf1d0a688e3eb5e6f0e23a72.jpg"
            alt="Kids art classes at Art Den Studio Nazareth PA"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          {/* Color overlay */}
          <div className="absolute inset-0 transition-all duration-500" style={{ background: 'linear-gradient(to top, rgba(255,67,34,0.88) 0%, rgba(255,113,32,0.5) 40%, rgba(0,0,0,0.25) 100%)' }} />

          {/* Top badge */}
          <div className="absolute top-8 left-8">
            <span className="font-outfit text-xs font-bold tracking-widest3 uppercase text-white/80 bg-black/30 backdrop-blur-sm px-4 py-1.5 rounded-full border border-white/15">
              Ages 4+
            </span>
          </div>

          {/* Big watermark number */}
          <div className="absolute top-8 right-8 font-cormorant text-[140px] font-bold text-white/5 leading-none select-none pointer-events-none" style={{ lineHeight: 1 }}>01</div>

          <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10">
            {/* Decorative paint blotch icon */}
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/15 backdrop-blur-sm mb-5">
              <i className="ri-parent-line text-white text-2xl"></i>
            </div>
            <h3 className="font-cormorant text-4xl md:text-5xl font-semibold text-white mb-4 leading-tight">
              Kids Art Classes
            </h3>
            <p className="font-outfit text-white/85 text-base leading-relaxed mb-6 max-w-sm">
              Colorful, playful sessions that spark imagination. From guided painting to themed birthday parties — your kids leave proud and inspired.
            </p>
            <div className="flex flex-wrap gap-2 mb-7">
              {['Beginner-Friendly', 'All Supplies', 'Ages 4+', 'Birthday Parties'].map((tag) => (
                <span key={tag} className="font-outfit text-xs text-white/90 bg-white/15 border border-white/20 px-3 py-1 rounded-full backdrop-blur-sm">
                  {tag}
                </span>
              ))}
            </div>
            <Link
              to="/art-classes"
              className="inline-flex items-center gap-2.5 bg-white text-artden-coral font-semibold px-7 py-3.5 rounded-full transition-all hover:bg-artden-paper whitespace-nowrap text-sm group-hover:gap-4"
            >
              Explore Kids Classes
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>

        {/* Adults side */}
        <div className="relative min-h-[520px] group overflow-hidden cursor-pointer">
          <img
            src="https://readdy.ai/api/search-image?query=sophisticated%20adults%20evening%20wine%20paint%20night%20studio%20friends%20creating%20paintings%20together%20candlelit%20warm%20atmospheric%20cozy%20romantic%20creative%20social%20gathering%20artisan%20premium%20photography%20vibrant%20canvases%20brushwork&width=800&height=650&seq=audience-adults-v3&orientation=landscape"
            alt="Adult art classes and events at Art Den Studio"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          {/* Color overlay */}
          <div className="absolute inset-0 transition-all duration-500" style={{ background: 'linear-gradient(to top, rgba(14,14,14,0.93) 0%, rgba(224,40,90,0.25) 50%, rgba(0,0,0,0.2) 100%)' }} />

          {/* Top badge */}
          <div className="absolute top-8 right-8">
            <span className="font-outfit text-xs font-bold tracking-widest3 uppercase text-white/80 bg-black/30 backdrop-blur-sm px-4 py-1.5 rounded-full border border-white/15">
              All Levels
            </span>
          </div>

          {/* Big watermark number */}
          <div className="absolute top-8 left-8 font-cormorant text-[140px] font-bold text-white/5 leading-none select-none pointer-events-none" style={{ lineHeight: 1 }}>02</div>

          <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/15 backdrop-blur-sm mb-5">
              <i className="ri-goblet-line text-white text-2xl"></i>
            </div>
            <h3 className="font-cormorant text-4xl md:text-5xl font-semibold text-white mb-4 leading-tight">
              Adult Classes & Events
            </h3>
            <p className="font-outfit text-white/85 text-base leading-relaxed mb-6 max-w-sm">
              Paint nights, bachelorettes, corporate events, and private parties. Refined, social, and genuinely unforgettable — guided by Kelsey.
            </p>
            <div className="flex flex-wrap gap-2 mb-7">
              {['Paint Nights', 'Private Parties', 'Bachelorette', 'Corporate'].map((tag) => (
                <span key={tag} className="font-outfit text-xs text-white/90 bg-white/15 border border-white/20 px-3 py-1 rounded-full backdrop-blur-sm">
                  {tag}
                </span>
              ))}
            </div>
            <Link
              to="/parties-events"
              className="inline-flex items-center gap-2.5 bg-artden-coral text-white font-semibold px-7 py-3.5 rounded-full transition-all hover:brightness-110 whitespace-nowrap text-sm group-hover:gap-4"
            >
              View Adult Experiences
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>

      {/* Bridge CTA */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 pb-20 pt-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 border border-white/8 rounded-2xl p-5 md:p-6" style={{ background: '#1a1a1a' }}>
          <p className="font-outfit text-white/50 text-sm">Not sure which experience fits you best?</p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 border border-white/20 hover:border-artden-coral text-white hover:text-artden-coral font-semibold px-6 py-3 rounded-full text-sm transition-all whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-question-answer-line"></i>
            </span>
            Ask Us Anything
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AudienceSegment;
